import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { theme } from '@styles/theme';
const Container = styled.div `
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.background.primary};
  padding: ${theme.spacing.md};
`;
const Content = styled.div `
  width: 100%;
  max-width: 400px;
`;
const Logo = styled.div `
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
`;
const LogoText = styled.h1 `
  font-size: ${theme.typography.fontSize['3xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.primary};
  letter-spacing: -0.02em;
`;
const Tagline = styled.p `
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.text.muted};
  margin-top: ${theme.spacing.xs};
`;
export function AuthLayout({ children }) {
    return (_jsx(Container, { children: _jsxs(Content, { children: [_jsxs(Logo, { children: [_jsx(LogoText, { children: "Shift" }), _jsx(Tagline, { children: "Prototype Platform" })] }), children] }) }));
}
